import { render, staticRenderFns } from "./BtnShowDoctors.vue?vue&type=template&id=8d75ed88&"
import script from "./BtnShowDoctors.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BtnShowDoctors.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d75ed88')) {
      api.createRecord('8d75ed88', component.options)
    } else {
      api.reload('8d75ed88', component.options)
    }
    module.hot.accept("./BtnShowDoctors.vue?vue&type=template&id=8d75ed88&", function () {
      api.rerender('8d75ed88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue"
export default component.exports